import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Shield, Bell, CheckCircle } from "lucide-react";

interface ThreeStepsProtectionProps {
  companyName: string;
  companyColor: string;
}
const ThreeStepsProtection = ({
  companyName,
  companyColor
}: ThreeStepsProtectionProps) => {
  const steps = [{
    icon: Bell,
    title: "Vorfall erkennen",
    description: "24/7 Monitoring erkennt Cyberangriffe sofort. Ihre Systeme sind rund um die Uhr geschützt.",
    time: "Sofort"
  }, {
    icon: Shield,
    title: "Schnelle Reaktion",
    description: "Expertenteam wird aktiviert. Forensik und Schadensbegrenzung beginnen umgehend.",
    time: "Innerhalb von 4 Stunden"
  }, {
    icon: CheckCircle,
    title: "Wiederherstellung",
    description: "Vollständige Systemwiederherstellung und Regulierung. Ihre Praxis ist wieder einsatzbereit.",
    time: "Je nach Schadensumfang"
  }];
  return (
    <section className="py-12 sm:py-16 lg:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 sm:mb-8 lg:mb-10">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-2 sm:mb-3">
            So funktioniert der Schutz in 3 Schritten
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground max-w-2xl mx-auto">
            Von der Erkennung bis zur vollständigen Wiederherstellung – {companyName} steht Ihnen zur Seite
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <Card 
                key={index} 
                className="group relative overflow-hidden
                  backdrop-blur-xl
                  bg-white/[0.115]
                  border-2 border-accent/40
                  rounded-[33px]
                  p-6
                  shadow-[2px_8px_8px_rgba(0,0,0,0.3)]
                  hover:scale-[1.02]
                  hover:border-accent/60
                  transition-all duration-200
                  flex flex-col h-full"
              >
                {/* Hover Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-accent/8 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none rounded-[33px]" />
                
                <div className="relative z-10 flex flex-col h-full">
                  <CardHeader className="p-0 pb-4">
                    <div className="w-14 h-14 rounded-full bg-accent/20 flex items-center justify-center mb-4 shadow-[inset_0_2px_8px_rgba(0,0,0,0.3),0_4px_12px_rgba(139,195,74,0.2)]">
                      <Icon className="w-7 h-7 text-accent" />
                    </div>
                    <CardTitle className="text-base sm:text-lg font-semibold leading-tight">{step.title}</CardTitle>
                    <div className="text-xs text-muted-foreground font-semibold mt-2">
                      ⏱️ {step.time}
                    </div>
                  </CardHeader>
                  <CardContent className="p-0 flex-1">
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </CardContent>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
export default ThreeStepsProtection;
